import { HttpClient } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../environments/environment';

@Injectable()
export class MemberByUserProfileService {

    constructor(private http: HttpClient) { }

    getMemberList(searchType, searchData) {
        return this.http.get(environment.BASE_URL_HRD +
            'tmMng/searchProfile/' + searchType + '/' + searchData)
    }

    getPanelsList(grantId) {
        let grantIdValue = grantId ? grantId : 0
        return this.http.get(environment.BASE_URL_HRD +
            'tmMng/getRgaDisciplinaryCodeLabelValues/' + grantIdValue)
    }


    public  saveNewMemberDetailsInAdministrative(payload,isValuePresentInDisciplinary?) {
        payload.panelTypeCodeId = +localStorage.getItem("TEAM_CODE")
        if(payload.isPanelUpdated){
          delete payload.isPanelUpdated
        }
       
        for(let i=0;i<payload.rgaRoleViewDtoList.length;i++){
            if(payload.rgaRoleViewDtoList[i].rgaPanelMemberId || payload.rgaRoleViewDtoList[i].rgaPanelMemberId==null){
                delete payload.rgaRoleViewDtoList[i].rgaPanelMemberId
                
            }
            if(payload.rgaRoleViewDtoList[i].panelId || payload.rgaRoleViewDtoList[i].panelId == null){
                delete payload.rgaRoleViewDtoList[i].panelId
            }
        }
     
        return this.http.post(environment.BASE_URL_HRD +
            "tmMng/saveAdministrativePanel", payload)
      }
      

}
